import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";

/* 🔹 Async API call */
export const fetchMaintenanceSettings = createAsyncThunk(
  "maintenance/fetchSettings",
  async (_, thunkAPI) => {
    try {
      const response = await agent.get(API.GET_MAINTAINENCE_SETTING);
      return response.data?.data || {};
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const pageSlice = createSlice({
  name: "page",
  initialState: {
    setting: {
      start_date_time: null,
      end_date_time: null,
      notification_message: "",
      site_maintenance_mode: 0,
      site_maintenance_message: "",
      site_maintenance_notification: false,
    },
    showMarquee: false,
    loading: false,
    error: null,
  },
  reducers: {
    setShowMarquee(state, action) {
      state.showMarquee = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMaintenanceSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaintenanceSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.setting = {
          start_date_time: action.payload.start_date_time,
          end_date_time: action.payload.end_date_time,
          notification_message: action.payload.notification_message,
          site_maintenance_mode: action.payload.site_maintenance_mode,
          site_maintenance_message: action.payload.site_maintenance_message,
          site_maintenance_notification:
            action.payload.site_maintenance_notification,
        };
      })
      .addCase(fetchMaintenanceSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setShowMarquee } = pageSlice.actions;
export default pageSlice.reducer;
